import {
  Component, Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent extends BaseComponent implements OnChanges {
  optionLabel: string = 'title';

  @Input() options: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.options && Object.keys(this.options[0] || {}).includes('title')) {
      this.optionLabel = 'title';
    } else {
      this.optionLabel = 'representation';
    }
  }
}
